module.exports = __webpack_public_path__ + "img/cowise2.4c56fb6e.png";